export default __webpack_public_path__ + "static/37040d0aa4b27f28bf90da0455d3f416.jpg";